import React, { useEffect, useState, useMemo } from 'react';
import FFTComparisonConanairSelectItem, { SelectItemRefreshData } from './FFTComparisonConanairSelectItem';
import FFTComparisonConanairFrequency from './FFTComparisonConanairFrequency';
import { SelectDataType } from './FFTComparisonConanair';
import { GraphData } from './FFTComparisonConanairChart';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { Table, TableBody, TableCell, TableRow } from '@material-ui/core';

const useStyles = makeStyles(
  createStyles({
    tdStyle: {
      padding: 0,
    },
  })
);

type Props = {
  refreshData: SelectItemRefreshData;
  selectData: SelectDataType;
  measurementName: string;
  graphData: GraphData | undefined;
  onChangeSelectDataEvent: (selectData: SelectDataType) => void;
  onChangeSelectDataDispUpDateEvent: (selectData: SelectDataType) => void;
  isBlankSelect: boolean;
  isUnitSelect: boolean;
  onClickUnitSelect: () => void;
  onAutoRangeSet: (data: boolean) => void;
};

const FFTComparisonConanairInfo: React.FC<Props> = (props) => {
  const classes = useStyles();

  //console.debug(['FFTComparisonInfo - 画面描画開始 -', props]);
  return (
    <Table>
      <TableBody>
        <TableRow>
          <TableCell className={classes.tdStyle}>
            <FFTComparisonConanairSelectItem
              refreshData={props.refreshData}
              selectData={props.selectData}
              measurementName={props.measurementName}
              onChangeSelectDataEvent={(e) => props.onChangeSelectDataEvent(e)}
              onChangeSelectDataDispUpDateEvent={(e) => props.onChangeSelectDataDispUpDateEvent(e)}
              itemColor={props.selectData.lineColor}
              isBlankSelect={props.isBlankSelect}
              isUnitSelect={props.isUnitSelect}
              onClickUnitSelect={() => {
                props.onClickUnitSelect();
              }}
              onAutoRangeSet={props.onAutoRangeSet}
            />
          </TableCell>
          <TableCell className={classes.tdStyle}>
            <FFTComparisonConanairFrequency graphData={props.graphData} />
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};

export default FFTComparisonConanairInfo;
